import { useEffect, type JSX } from 'react';
import { useCountdownTimer } from 'src/hooks';
import Countdown from './Countdown';

interface BehindCountdownProps {
  children: JSX.Element;
  durationInMs: number;
  onCountdownFinished: () => void;
}

const BehindCountdown = ({
  onCountdownFinished,
  durationInMs,
  children,
}: BehindCountdownProps): JSX.Element => {
  const { timeLeftMs } = useCountdownTimer({
    durationInMs,
    intervalInMs: 1000,
  });
  const timerHasElapsed = timeLeftMs <= 0;

  useEffect(() => {
    if (timerHasElapsed) {
      onCountdownFinished();
    }
  }, [timerHasElapsed, onCountdownFinished]);

  if (timerHasElapsed) return children;
  return <Countdown number={Math.floor(timeLeftMs / 1000)} />;
};

export default BehindCountdown;
